import styled from 'styled-components';
import {Collapse, Radio, Space} from 'antd';
import {typographyStyles} from '../../../../utils/styles';
import DetailsTable from '../../TransactionsPage/DetailsTable';


const StyledInvoiceDetailsCard = styled(Collapse)`
  .ant-collapse-header {
    background-color: ${props => props.theme.colors.neutral_1};
    padding: 16px 24px 0 24px;
  }
  
  .ant-collapse-content {
    border-top: none;
    padding: 0 24px 16px 24px;
    
    .ant-collapse-content-box {
      padding: 0;
    }
  }
  
  .ant-collapse-item {
    border-radius: 4px !important;
    
    .ant-collapse-header {
      background-color: ${props => props.theme.colors.neutral_1};
      border-radius: 4px !important;
      padding: 16px 24px;
      
      .ant-collapse-header-text {
        ${typographyStyles.heading.h5};
      }
    }
  }
  
  
  form {
    
    .ant-form-item {
      margin-bottom: 0;
    }
    
    .ant-form-item-control-input,
    .ant-picker {
      width: 214px;
    }
    
    .invoice-vendor-select {
      .ant-form-item-control-input {
        max-width: 214px;
        width: max-content;
      }
    }
    
    .ant-form-item-label {
      display: none;
    }
    
    .ant-input {
      text-align: right;
    }

    .ant-input,
    .ant-input-affix-wrapper,
    .ant-picker {
      &:not(:active):not(:focus):not(:hover) {
        border-color: transparent;
      }
    }
    
    .ant-picker {
      &.ant-picker-disabled {
        background: transparent;
        &:active,
        &:focus,
        &:hover {
          border-color: transparent;
        }
      }
      
      .ant-picker-input {
        input {
          margin-right: 8px;
          text-align: right;
          
          &[disabled] {
            color: rgba(0, 0, 0, 0.88);
          }
        }
      }
    }
    
    .ant-form-item-with-help {
      text-align: left;
    }
    
    .amount-input {
      .ant-input-prefix {
        color: ${props => props.theme.colors.neutral_6};
      }
      .ant-input-affix-wrapper {
        display: flex;
        justify-content: end;
        flex-direction: row;
      }
      input {
        min-width: 30px;
      }
    }
    
    .amount-ghost-test {
      position: absolute;
      visibility: hidden;
    }
    
    .invoice-vendor-select {
      .ant-dropdown-trigger {
        border-color: transparent;
        font-size: 14px;
        justify-content: end;
        min-height: 32px;
        padding: 4px 12px;
        
        &:hover {
          border-color: ${props => props.theme.colors.primary_8};
        }
      }
    }
  }
`;

const StyledInvoiceDetailsCardRadioGroup = styled(Radio.Group)`
  label {
    &:last-of-type {
      margin-inline-end: 0;
      
      span.ant-radio+* {
        padding-inline-end: 0;
      }
    }
  }
`;

const StyledInvoiceDetailsCardVendorSpace = styled(Space)`
  justify-content: end;
`;

const StyledInvoiceDetailsCardTable = styled(DetailsTable)`
  tr {
    min-height: 34px;
    
    &:not(:last-of-type) {
      margin-bottom: 0;
    }
  }
`

export {
  StyledInvoiceDetailsCard,
  StyledInvoiceDetailsCardRadioGroup,
  StyledInvoiceDetailsCardVendorSpace,
  StyledInvoiceDetailsCardTable,
}
